import React from 'react';
import dayjs from 'dayjs';
import Footer, { FooterLeft, FooterRight } from '../../../components/layouts/Footer/Footer';
import { useTranslation } from 'react-i18next';

const DefaultFooterTemplate = () => {
	const { t } = useTranslation();
	return (
		<Footer>
			<FooterLeft className='text-zinc-500'>
				<div>
					{t('Copyright')} © {dayjs().format('YYYY')}
				</div>
			</FooterLeft>
			<FooterRight className='text-zinc-500'>
				<span>
					© {t('All rights reserved.')} {t('Made by CentraSync')}
				</span>
			</FooterRight>
		</Footer>
	);
};

export default DefaultFooterTemplate;
